// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2fJz9","clinicsSelect":"TableHeading_clinicsSelect__39WBF"};